import React, { ReactNode } from 'react';
import DialogDetalheTitulo from './DialogDetalheTitulo';
import { createGenericModalContext } from '../../../../../components/BasicComponents/GenericModalContext';

const { GenericModalProvider, useGenericModal } = createGenericModalContext<string>();

export const ModalDetalheTituloProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <GenericModalProvider
            ModalComponent={DialogDetalheTitulo}
            urlParam="detalhe-titulo-receber"
        >
            {children}
        </GenericModalProvider>
    );
};

export const useModalDetalheTitulo = useGenericModal;